import { useEffect, useState } from 'react'

const useYoutubeThumbnail = (videoId: string) => {
  const [thumbnailUrl, setThumbnailUrl] = useState('')

  useEffect(() => {
    const thumbnailTypes = [
      'maxresdefault',
      'hqdefault',
      'mqdefault',
      'sddefault',
      'default'
    ]
    let i = 0
    const img = new Image()
    const handleError = () => {
      i += 1
      if (i < thumbnailTypes.length) {
        img.src = `https://i.ytimg.com/vi/${videoId}/${thumbnailTypes[i]}.jpg`
      }
    }
    img.addEventListener('load', () => {
      if (img.width === 120 && img.height === 90) {
        // L'immagine contiene i 3 puntini di youtube
        handleError()
      } else {
        setThumbnailUrl(img.src)
      }
    })
    img.addEventListener('error', handleError)
    img.src = `https://i.ytimg.com/vi/${videoId}/${thumbnailTypes[i]}.jpg`

    return () => {
      img.removeEventListener('load', () => {})
      img.removeEventListener('error', handleError)
    }
  }, [videoId])

  return thumbnailUrl
}

export default useYoutubeThumbnail
